<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    :submitTitle="submitTitle"
    icon="fa-donate"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <FormRow label="Name"><FormInputText placeholder="Name" v-model="taxRate.name" field="name" /></FormRow>
      <FormRow label="Code"><FormInputText placeholder="Code" v-model="taxRate.code" field="code" /></FormRow>
      <FormRow label="Rate"><FormInputText type="number" placeholder="Rate" v-model="taxRate.rate" field="rate" addon="%" /></FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: 'TaxRateEditDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    isCreateMode: Boolean
  },
  data() {
    return {
      taxRateId: null,
      taxRate: {},
      dialogForm: {},
      submitting: false
    }
  },
  mounted() {
  },
  computed: {
    title() {
      return this.isCreateMode ? 'New Tax Rate' : 'Edit Tax Rate'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    }
  },
  methods: {
    show(taxRate) {
      // Reset form
      this.taxRate = {
      }
      this.taxRateId = 0
      this.dialogForm = {}
      this.submitting = false

      if(taxRate != null) {
        this.taxRate = _.cloneDeep(taxRate)
        this.taxRateId = taxRate.id
      }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = _.cloneDeep(this.$data.taxRate)

      if(this.isCreateMode) {
        this.$apiService.adminService.createTaxRate(updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.dialogForm = this.processFormResponse(err)
        })
      } else {
        this.$apiService.adminService.updateTaxRate(this.taxRateId, updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.dialogForm = this.processFormResponse(err)
        })
      }
    }
  }
}
</script>